
import { Component, Prop, Vue } from 'bits/vue'
import OzBox, { OzBoxColors } from 'library/v4/components/OzBox.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from 'library/v4/components/OzContainedButton.vue'

export interface OzBaseDialogBoxButtonData {
  text: string
  emit: string
  colorScheme: OzContainedButtonColorScheme
  testId?: string
  disabled?: boolean
}

@Component({ components: { OzBox, OzContainedButton } })
export default class OzBaseDialogBox extends Vue {
  OzBoxColors = OzBoxColors

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * List of data to generate buttons.
   */
  @Prop() buttons!: OzBaseDialogBoxButtonData[]

  /**
   * Determines if each button should fill the width of the dialog.
   */
  @Prop({ default: false }) forceFullWidthButtons!: boolean

  select(buttonEvent): void {
    /**
     * Emits events passed in via the `buttons` prop.
     * @event buttonEvent
     */
    this.$emit(buttonEvent)
  }
}

export { OzContainedButtonColorScheme }
